<template>
    <div class="popup-contract popup-all popup-ct-sms" >
        <div class="popup-container">
            <div class="popup-vue">
                <img class="popup-close" src="/img/credit-landing-vue/popup-close.svg" alt="Close" @click="popupClose()">
                <div class="popup-title" v-html="__t('Згода на обробку персональних даних SMS')"></div>
                <div class="popup-description content">
                    <div v-html="__t('Згода на обробку sms')"></div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

  export default {
    name: 'popup-contract-sms',
    data() {
      return {

      }
    },
    methods: {
        __t(phrase) {
            return window.__t(phrase);
        },
        popupOpen: function() {
            this.$el.style.display = 'block';
        },
        popupClose: function() {
            this.$el.style.display = 'none';
        },

    }
  }

</script>